module.exports = __webpack_public_path__ + "img/frame_two.35ab2c88.png";